import { format } from "date-fns";

/**
 * Normalizes updatedAt from Firestore (Timestamp), string, or missing to a Date or null.
 * Used for sorting and for passing to formatNotificationUpdatedAt.
 * @param {import("firebase/firestore").Timestamp | string | Date | null | undefined} value
 * @returns {Date | null}
 */
export function normalizeUpdatedAtToDate(value) {
   if (value == null) return null;
   try {
      const date = typeof value?.toDate === "function" ? value.toDate() : new Date(value);
      return Number.isFinite(date.getTime()) ? date : null;
   } catch {
      return null;
   }
}

/**
 * Formats updatedAt for display: "Jan 16 • 11:16 AM" or empty string if missing/invalid.
 * Accepts Firestore Timestamp, Date, string, or null/undefined.
 * @param {import("firebase/firestore").Timestamp | string | Date | null | undefined} value
 * @returns {string}
 */
export function formatNotificationUpdatedAt(value) {
   const date = normalizeUpdatedAtToDate(value);
   if (!date) return "";
   return format(date, "MMM d • h:mm a");
}
